import { defineCustomElement } from '~/lit/define-custom-element';
import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';

class BinCurrentReportDate extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    const date = this.entity?.properties?.publishedAt;
    const formattedDate = date ? this.localizedFormatDate(date, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : this.t('legacyLit.binCurrentReportDate.unknown');

    return html`${formattedDate}`;
  }
}

defineCustomElement('bin-current-report-date', BinCurrentReportDate);
